(() => {
  if (window.UcwPdpUtils) return;

  const quantity = (value) => {
    const number = Math.floor(Number(value));
    return Number.isSafeInteger(number) && number > 0 ? number : 1;
  };

  const cartUrl = (action) => `${window.Shopify?.routes?.root || '/'}cart/${action}.js`;

  const postCart = async (action, payload) => {
    if (window.UcwCart) return window.UcwCart.request(action, payload);
    let response;
    try {
      response = await fetch(cartUrl(action), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch (error) {
      throw new Error('De verbinding is onderbroken. Controleer uw winkelwagen voordat u opnieuw probeert.');
    }
    let result;
    try { result = await response.json(); } catch (error) { result = null; }
    if (!response.ok) {
      throw new Error(typeof result?.description === 'string'
        ? result.description
        : 'Toevoegen is niet gelukt. Controleer uw winkelwagen en probeer het opnieuw.');
    }
    return result;
  };

  const showError = (container, message) => {
    let element = container.querySelector('[data-ucw-cart-error]');
    if (!element) {
      element = document.createElement('p');
      element.className = 'ucw-pdp-cart-error';
      element.dataset.ucwCartError = '';
      element.setAttribute('role', 'alert');
      container.appendChild(element);
    }
    element.textContent = message || '';
    element.hidden = !message;
  };

  const trapFocus = (event, container) => {
    if (event.key !== 'Tab') return;
    const controls = Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => element.getClientRects().length && !element.closest('[hidden]'));
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  };

  const delivery = (now = new Date()) => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(now).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
    const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
    const day = date.getUTCDay();
    const beforeCutoff = parts.hour < 17;
    const days = day >= 1 && day <= 4 ? (beforeCutoff ? 1 : 2)
      : day === 5 ? (beforeCutoff ? 1 : 4) : day === 6 ? 3 : 2;
    date.setUTCDate(date.getUTCDate() + days);
    const formatted = new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
    }).format(date);
    return { days, date: date.toISOString().slice(0, 10), text: days === 1 ? `morgen (${formatted}) in huis` : `${formatted} in huis` };
  };

  window.UcwPdpUtils = Object.freeze({ quantity, postCart, showError, trapFocus, delivery });
})();
